// extracted by css-extract-rspack-plugin
export default {"projectFilterButton":"ListProjectFilter-module__projectFilterButton__2W17lj_"};